import React from "react";
import FieldText, { FieldTextProps } from "ui/Form/Text";
import FieldDate from "ui/Form/Date";
import FieldSearch from "ui/Form/Search";

import { Field, UseFieldConfig } from "react-final-form";

type Props = FieldTextProps & UseFieldConfig<string>;

const TextField: React.FC<Props> = ({
    labelProps,
    fieldGroupProps,
    fieldControlProps,
    fieldControlParser,
    adornmentStart,
    adornmentEnd,
    adornmentEndProps,
    inputProps,
    infoMessage,
    ...fieldProps
}) => {
    return (
        <Field name={inputProps.name} parse={fieldControlParser} format={fieldControlParser} {...fieldProps}>
            {({ input, meta }) => {
                if (inputProps.type === "date") {
                    return (
                        <FieldDate
                            error={!!(meta.error || meta.submitError)}
                            errorMessage={meta.error || meta.submitError}
                            labelProps={labelProps}
                            fieldGroupProps={fieldGroupProps}
                            fieldControlProps={fieldControlProps}
                            adornmentStart={adornmentStart}
                            adornmentEnd={adornmentEnd}
                            inputProps={Object.assign({}, input, inputProps)}
                            infoMessage={infoMessage}
                        />
                    );
                } else if (inputProps.type === "search") {
                    return <FieldSearch inputProps={Object.assign({}, input, inputProps, { type: "text" })} />;
                } else {
                    return (
                        <FieldText
                            error={!!(meta.error || meta.submitError)}
                            errorMessage={meta.error || meta.submitError}
                            labelProps={labelProps}
                            fieldGroupProps={fieldGroupProps}
                            fieldControlProps={fieldControlProps}
                            adornmentStart={adornmentStart}
                            adornmentEnd={adornmentEnd}
                            adornmentEndProps={adornmentEndProps}
                            inputProps={Object.assign({}, input, inputProps)}
                            infoMessage={infoMessage}
                        />
                    );
                }
            }}
        </Field>
    );
};

export default TextField;
